<template lang="html">
  <div class="wrapper-publica text text--negro4">
    <nav class="navbar">
      <a href="/" class="navbar-brand">
        <img src="/static/logo-blanco.png">
      </a>
    </nav>
    <br>
    <div class="info-nota">
      <nota/>
      <div class="grid">
        <div class="col-md-12">
          <p class="clausula">
            CLAUSULA DE CONFIDENCIALIDAD: toda la información suministrada en este enlace es
            generada exclusivamente para el destinatario directo y sus contactos a nivel
            institucional relacionados con la información suministrada, por lo que su uso es
            estrictamente confidencial y no puede ser suministrado a terceros ajenos al
            destinatario. Informes, sus formatos, así como la asistencia técnica y logística a que
            tengan acceso los clientes de Controles Video Técnicos de Costa Rica sociedad anónima no
            deberán ser revelados a terceros. Los logotipos y el nombre de Controles Video Técnicos
            de Costa Rica sociedad anónima, son propiedad exclusiva de Controles Video Técnicos de
            Costa Rica sociedad anónima y su uso es exclusivamente reservado para su propietario,
            marcas y logotipos se encuentran debidamente registrados como derechos de autor en el
            Registro Nacional de Marcas y afines.
          </p>
        </div>
      </div>
    </div>
    <div class="footer-publica">
      <div class="grid grid--padding contacto">
        <div class="col-sm-1 esconder"/>
        <div class="col-sm-9">
          <div class="footer-text">
            <ul class="no--list-style">
              <li>
                <i class="fa fa-fw fa-phone"/>&emsp;+(506) 2218-1924
              </li>
              <li>
                <i class="fa fa-fw fa-phone"/>&emsp;+(506) 2251-3000
              </li>
              <li>
                <i class="fa fa-fw fa-envelope"/>&emsp;
                <a class="link" href="mailto:monitoreo@controles.co.cr">
                  monitoreo@controles.co.cr
                </a>
              </li>
              <li>
                <i class="fa fa-fw fa-map-marker"/>&emsp;Desamparados, San José, Costa Rica
              </li>
              <li>
                <i class="fa fa-fw fa-clock"/>&emsp;Lunes a Viernes - 05:30 AM a 11:30 PM
              </li>
            </ul>
          </div>
        </div>
        <div class="link-logo">
          <a href="http://controles.co.cr/" class="link">
            <img class="esconder" src="/static/controles_contra.png">
            <img class="mostrar" src="/static/controles_full_rojo.png">
          </a>
        </div>
      </div>
    </div>
    <div class="row copyright">
      <div class="col-sm-12">
        <p class="text--center">
          &copy; 2018 | Desarrollado por &nbsp;<img src="/static/pajaro.png" width="25px">
          <a class="link" href="http://www.ciriscr.com/">Ciris Informatic Solutions S.A.</a>
          <span>| 3-101-625445</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import nota from "./Nota.vue";

export default {
  components: {
    nota,
  },
};
</script>

<style lang="scss">
@import "../../sass/base/colores";
@import "../../sass/tema/colores";

.wrapper-publica {
  background-color: $grise;
  .navbar {
    background-color: $negro2;
    height: 48px;
    padding: 15px;
    .navbar-brand > img {
      max-width: 167px;
      margin-top: -14px;
    }
  }
  .footer-publica {
    border-top: 3px solid $rojo-tema;
    background-color: $negro2;
    color: $grisc;
    padding: 15px;
    line-height: 1.846;
    .esconder{
      display: none;
    }
    .link-logo{
      position: absolute;
      width: 25%;
      top: 15px;
      right: 15px;
      img{
        width: 100%;
      }
    }
  }
  video {
    width: 100%;
    max-width: 320px;
  }
}
.copyright {
  background-color: #3a3a3a;
  padding-top: 4px;
  color: #666;
}
@media (min-width: 768px) {
  .wrapper-publica {
    .footer-publica {
      padding: 15px 0px !important;
      .link-logo{
        right: 7.5%;
      }
      .esconder{
        display: block;
      }
      .mostrar{
        display: none !important;
      }
    }
  }
}
.contacto {
  position: relative;
}
.clausula {
  margin: 10px 0px 30px 0px;
  line-height: 1.5;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/notas/NotaPublica.vue